import { DisplayOptionsContext } from "@/pages/human-resources/time-management/model/display-options/DisplayOptionsContext.ts";
import type { DisplayOptions } from "@/pages/human-resources/time-management/model/display-options/DisplayOptions.ts";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";

export default function useDisplayOptionsState(): DisplayOptions {
  return useDefinedContextValue(DisplayOptionsContext);
}
